import { getAllBooth, getAllCountry, getAllCategory, createAdvertisment, createAdvertismentGallery, getAllProvince, getAllCity, getAllRegion } from "../../../api/advertisment/create/index.js";
import { Box, Button, Paper, Step, StepLabel, Stepper } from "@mui/material";
import { useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";

import { toast } from "react-toastify";
import { PageTitle } from "../../../../../shared/ui/common/index.js";



import { logout } from "../../../../../shared/state/slices/user.js";
import Address from "./address.jsx";
import FeildAdsValue from "./fields.jsx";
import StepOne from "./forms.jsx";

const CreateAds = () => {
  const [createdId, setCreatedId] = useState(null);
  const [currentStep, setCurrentStep] = useState(1);
  const [data, setData] = useState({ files: [], selectedProductImage: [] });
  const [createdName, setCreatedName] = useState("");
  const [error, setError] = useState();
  const [loading, setLoading] = useState(false);
  const [showingCats, setShowingCats] = useState([]);
  const [country, setCountry] = useState([]);
  const [states, setStates] = useState([]);

  const [cities, setCities] = useState([]);

  const [regions, setRegions] = useState([]);

  const [showingBooth, setShowingBooth] = useState([]);
  const [catSearchWord, setCatSearchWord] = useState("");
  const [boothSearchWord, setBoothSearchWord] = useState("");
  const dispatch = useDispatch();

  const { token } = useSelector((state) => state.user);

  const addProductSteps = ["تعریف تبلیغ", " ادرس ", "فرم های تبلغ"];
  useEffect(() => {
    getAllBooth(token)
      .then((res) => {
        const { data } = res;
        setShowingBooth(data?.data);
      })
      .catch((err) => {
        if (err.response.status === 401) {
          dispatch(logout());
        }
      });
    getAllCountry(token)
      .then((res) => {
        const { data } = res;
        setCountry(data?.data);
      })
      .catch((err) => {
        if (err.response.status === 401) {
          dispatch(logout());
        }
      });
    getAllCategory(token)
      .then((res) => {
        const { data } = res;
        setShowingCats(data?.data);
        /*    setCategory(data?.data[0]); */
      })
      .catch((err) => {
        if (err.response.status === 401) {
          dispatch(logout());
        }
      });
  }, []);
  /*   useEffect(() => {
    const notFilteredRows = [...showingCats];
    let afterFilterRows = notFilteredRows.filter((row) =>
      row.title.toLowerCase().includes(catSearchWord.toLowerCase())
    );

    setShowingCats(afterFilterRows);
  }, [catSearchWord, showingCats]);

  useEffect(() => {
    const notFilteredRows = [...showingBooth];
    let afterFilterRows = notFilteredRows.filter((row) =>
      row.title.toLowerCase().includes(catSearchWord.toLowerCase())
    );
    setShowingBooth(afterFilterRows);
  }, [boothSearchWord, showingBooth]); */
  const sumbitHandler = () => {
    var fromGallery = "";
    data?.selectedProductImage.map((item) => {
      fromGallery += `,${item}`;
    });
    let fd = new FormData();
    if (fromGallery !== "") fd.append("fromGallery", fromGallery.slice(1));
    for (let x = 0; x < data?.files.length; x++) {
      fd.append("files", data?.files[x]);
    }

    setError();
    setLoading(true);
    createAdvertisment(data, token)
      .then((res) => {
        if (res.data.code === 200) {
          setCreatedId(res.data.data.id);

          if (data?.files.length > 0 || fromGallery !== "") {
            createAdvertismentGallery(fd, token)
              .then((res) => {
                toast.success("با موفقیت اضافه شد");
                setLoading(false);
              })
              .catch((err) => {
                setLoading(false);
                toast.error(err.response?.data?.message);

                if (err.response.status === 401) {
                  dispatch(logout());
                }
              });
          } else {
            toast.success("با موفقیت اضافه شد");
            setLoading(false);
          }
        } else {
          toast.error("مشکلی در درخواست شما وجود دارد");
        }
      })
      .catch((err) => {
        toast.error(err.response?.data?.message);
        setLoading(false);

        if (err.response.status === 401) {
          dispatch(logout());
        }
      });
  };
  useEffect(() => {
    if (data?.countryId) {
      getAllProvince(data, token)
        .then((res) => {
          const { data } = res;
          setStates(data?.data);
        })
        .catch((err) => {
          if (err.response.status === 401) {
            dispatch(logout());
          }
        });
    } else {
      setStates([]);
    }
  }, [data?.countryId]);
  useEffect(() => {
    if (data?.provinceId) {
      getAllCity(data, token)
        .then((res) => {
          const { data } = res;
          setCities(data?.data);
        })
        .catch((err) => {
          if (err.response.status === 401) {
            dispatch(logout());
          }
        });
    } else {
      setCities([]);
    }
  }, [data?.provinceId]);
  useEffect(() => {
    if (data?.cityId) {
      getAllRegion(data, token)
        .then((res) => {
          const { data } = res;
          setRegions(data?.data);
        })
        .catch((err) => {
          if (err.response.status === 401) {
            dispatch(logout());
          }
        });
    } else {
      setRegions([]);
    }
  }, [data?.cityId]);
  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };
  const handleValidate = () => {
    if (!data?.title) {
      toast.error("عنوان  را وارد کنید");
      setError("title");
      scrollToTop();
    } else if (!data?.categoryId) {
      toast.error("دسته بندی  را وارد کنید");
      setError("categoryId");
      scrollToTop();
    } else if (!data?.contactNumber) {
      toast.error("شماره مخاطب  را وارد کنید");
      setError("contactNumber");
      scrollToTop();
    } else if (!data?.tag) {
      toast.error("تگ  را وارد کنید");
      setError("tag");
      scrollToTop();
    } else if (!data?.type) {
      toast.error("نوع  را وارد کنید");
      setError("type");
      scrollToTop();
    } else if (!data?.deposite) {
      toast.error("قیمت  را وارد کنید");
      setError("deposite");
      scrollToTop();
    } else if (!data?.priceType) {
      toast.error("نوع قیمت  را وارد کنید");
      setError("priceType");
      scrollToTop();
    }/*  else if (!data?.title) {
      toast.error("تاریخ پرداخت  را وارد کنید");
      setError("title");
      scrollToTop();
    } else if (!data?.title) {
      toast.error("تاریخ اعتبار  را وارد کنید");
      setError("title");
      scrollToTop();
    } */ else if (!data?.description) {
      toast.error("توضیحات  را وارد کنید");
      setError("description");
      scrollToTop();
    }else{
      setCurrentStep(2)
    }
  };
  return (
    <>
      <PageTitle
        title="ساخت تبلغات جدید "
        broadCrumb={[
          {
            title: "تبلیغات",
            path: "/advertisment",
          },
        ]}
      />
      <div className="px-3 biggerButton">
        <Box
          sx={{
            width: "100%",
            my: 1,
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
          }}
        >
          {" "}
          <Paper
            elevation={0}
            className=" rounded-lg border border-[#dbdfea] py-3 flex items-center px-4 w-full mb-4"
          >
            {" "}
            <Button
              onClick={() => {
                setCurrentStep((r) => r - 1);
              }}
              variant="outlined"
              disabled={currentStep === 1}
            >
              مرحله قبل
            </Button>
            <Stepper
              activeStep={currentStep - 1}
              alternativeLabel
              sx={{
                direction: "ltr",

                width: "100%",
                backgroundColor: (theme) =>
                  theme.palette.mode === "light"
                    ? "#fff"
                    : theme.palette.background.paper,
              }}
            >
              {addProductSteps.map((label) => (
                <Step key={label}>
                  <StepLabel
                    sx={{
                      ".MuiStepLabel-label": {
                        fontSize: {
                          md: "0.9rem !important",
                          xs: "1rem !important",
                        },
                      },
                    }}
                  >
                    {label}
                  </StepLabel>
                </Step>
              ))}
            </Stepper>{" "}
            <Button
              /*   onClick={() => {
              if (currentStep === 1) {
                setCurrentStep(2);
              } else if (currentStep === 2) {
                setCurrentStep(3);
              } else if (currentStep === 3) {
                handleSumbit();
              }
            }} */
              onClick={() => {
                if (currentStep === 2) {
                  sumbitHandler();
                } else if (currentStep === 1) {
                  handleValidate();
                }
              }}
              variant="contained"
            >
              <> مرحله بعد</>
            </Button>
          </Paper>
          <Paper
            elevation={0}
            className="rounded-lg  border-[#dbdfea] border w-full py-6 md:px-5 px-2 flex flex-col gap-6"
          >
            {currentStep === 1 && (
              <StepOne
                setData={setData}
                data={data}
                setCatSearchWord={setCatSearchWord}
                setBoothSearchWord={setBoothSearchWord}
                catSearchWord={catSearchWord}
                boothSearchWord={boothSearchWord}
                showingBooth={showingBooth}
                showingCats={showingCats}
                error={error}
              />
            )}{" "}
            {currentStep === 2 && (
              <>
                <Address
                  states={states}
                  regions={regions}
                  cities={cities}
                  counteries={country}
                  setData={setData}
                  data={data}
                />
              </>
            )}
            {currentStep === 3 && (
              <>
                <FeildAdsValue />
              </>
            )}
            {/*
             */}
          </Paper>
        </Box>
      </div>
    </>
  );
};

export default CreateAds;
